import { IModel, IAttribute, IViolation } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeDataset } from './file-type.dataset';

import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'FileShare',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.FileShare_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.FileShare_DisplayText)
    ]
})
export class FileShareDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly FILE_FILTER: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_FileFilter,
        association: 'FILE_FILTER',
        templatable: true,
        constraint: {
            validator: FileShareDataset.validateFileFilter
        }
    })
    public fileFilter?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateFileFilter(dataset: FileShareDataset, fileFilter?: string): IViolation[] | undefined {
        if (dataset.fileName != null && dataset.fileName !== '') {
            if (fileFilter != null && fileFilter !== '') {
                return [
                    {
                        message: () => stringResources.Error_FileNameAndFilter
                    }
                ];
            }
        }
        return undefined;
    }
}
